const weekDays = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
var hour = new Date().getHours();

function parseDateExceptionsString(datesString) {
  var dates = datesString.replaceAll(" ", "");
  if (dates.length == 0) return [Date.today().addDays(-1)]; //add a fake passed day
  
  dates = dates.split(",");
  dates.forEach((date, index, array) => {
    array[index] = Date.parse(array[index]);
  });
  
  return dates;
}

function dateIsException(date, exceptions) {
  var isException = false;
  exceptions.forEach((exception) => {
    if ( date.compareTo(exception) === 0 ) {
      isException = true;
      return;
    }
  });
  
  return isException;
}

//if today is working day return today or next working day
function nextWorkingDay(today, schedule, exceptions) {
  var nextWorkingDay = today.clone();
  
  var workingDates = parseDateExceptionsString(exceptions.workingDates);
  var workingDatesNot = parseDateExceptionsString(exceptions.workingDatesNot);
  
  while (
    (!schedule[weekDays[nextWorkingDay.getDay()]] || dateIsException(nextWorkingDay, workingDatesNot))
    &&
    !dateIsException(nextWorkingDay, workingDates)
  ) {
    nextWorkingDay = nextWorkingDay.addDays(1);
  }
  
  return nextWorkingDay;  
}

function nextDeliveryDay(fulfillOn, schedule, exceptions) {
  //deliver next working day after fulfillment
  return nextWorkingDay(fulfillOn.clone().addDays(1), schedule, exceptions);
}

var pickingOn = Date.today();

//if it's passed picking hour, order will be picked up next working day (relative to pickup_days)
if(hour >= fulfillmentUntil) { 
  pickingOn = pickingOn.addDays(1);
}

pickingOn  = nextWorkingDay(pickingOn, pickingOnSchedule, pickingOnExceptions);

for (var i = 0; i < delayPickingOn; i++) {
  pickingOn = nextWorkingDay(pickingOn.addDays(1), pickingOnSchedule, pickingOnExceptions);
}

var fromDate = nextDeliveryDay(pickingOn, shippingOnSchedule, shippingOnExceptions);
var toDate = nextDeliveryDay(fromDate, shippingOnSchedule, shippingOnExceptions);

$('#shipping-estimation-time-from-date').html(fromDate.toLocaleDateString(Shopify.locale, { weekday: 'long', day: 'numeric' }));
$('#shipping-estimation-time-to-date').html(toDate.toLocaleDateString(Shopify.locale,     { weekday: 'long', day: 'numeric' }) + ' ' + toDate.toLocaleDateString(Shopify.locale,     { month: 'long' }));
